import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";

import { Button, Flex, Box, useDisclosure } from "@chakra-ui/react";

import { Form, Formik } from "formik";
import { FocusError } from "../../../components/FocusError";
import { ApadrinhamentoCadastrar } from "./Cadastrar";
import { VisualizarPageApadrinhamento } from "./Visualizar";

import * as Yup from "yup";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../utils/hasFormChanged";
import CriancaService from "../../../../main/services/CriancaService";
import Swal from "sweetalert2";
import { criancaFunc, Permission } from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import SemRegistros from "../../../components/SemRegistros";
import HistoricoApadrinhamento from "../../../components/HistoricoApadrinhamento";
import { isAfter, isBefore, isValid, parse, startOfDay } from "date-fns";

export const VisualizarApadrinhamento = () => {
  const { id } = useParams();
  const [isTrueVisualizar, setIsTrueVisualizar] = useState(true);
  const { roleKeycloack, user } = useAuthProvider();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const history = useHistory();
  const url = window.location.href;
  const {
    atualizarApadrinhamento,
    setAtualizarApadrinhamento,
    cadastrarApadrinhamento,
    setCadastrarApadrinhamento,
    setEditarApadrinhamentoCrianca,
    setCadastrarApadrinhamentoCrianca,
    setEditarCriancaCr,
    radioClick,
    setRadioClick,
    setAnexarCrianca,
    idPJ,
    primeiraMovimentacao,
  } = useAppContext();

  const schema = Yup.object().shape({
    pessoasProgramaApadrinhamento: Yup.array().when(
      ["sendoApadrinhado", "incluidoProgApadrinh"],
      {
        is: (sendoApadrinhado, incluidoProgApadrinh) =>
          sendoApadrinhado === "S" && incluidoProgApadrinh === "S",
        then: Yup.array()
          .of(
            Yup.object().shape({
              tipoPessoaProgApadrinha: Yup.object()
                .nullable()
                .required("Este campo é obrigatório!"),
              nomePessoaApadrinhamento: Yup.string()
                .trim()
                .required("Este campo é obrigatório!"),
              dataInicioApadrinhamento: Yup.string("Este campo é obrigatório!")
                .nullable()
                .required("Este campo é obrigatório!")
                .test("validDate", "Data inválida!", (value) => {
                  if (!!value) {
                    if (value.length === 10) {
                      return isValid(parse(value, "dd/MM/yyyy", new Date()));
                    } else {
                      return false;
                    }
                  } else {
                    return false;
                  }
                })
                .test("dataInicioAfterDataAcolhimento", "", function (value) {
                  if (!value || !primeiraMovimentacao) {
                    return true;
                  }

                  const date = new Date(primeiraMovimentacao);

                  const formattedDate = date.toLocaleDateString("pt-BR");

                  return !isBefore(
                    parse(value, "dd/MM/yyyy", new Date()),
                    startOfDay(parse(formattedDate, "dd/MM/yyyy", new Date()))
                  );
                })
                .test("dataNascimentoAfterToday", "", (value) => {
                  if (!value) {
                    return true;
                  } else {
                    return !isAfter(
                      parse(value, "dd/MM/yyyy", new Date()),
                      new Date()
                    );
                  }
                }),
              dataFimApadrinhamento: Yup.string("Este campo é obrigatório!")
                .nullable()
                .test("validDate", "Data inválida!", (value) => {
                  if (!!value) {
                    if (value.length === 10) {
                      return isValid(parse(value, "dd/MM/yyyy", new Date()));
                    } else {
                      return false;
                    }
                  } else {
                    return true;
                  }
                })
                .test("dataApadrinhamentoFimAfterInicio", "", function (value) {
                  const { dataInicioApadrinhamento } = this.parent;
                  if (!value || !dataInicioApadrinhamento) {
                    return true;
                  }
                  return !isBefore(
                    parse(value, "dd/MM/yyyy", new Date()),
                    startOfDay(
                      parse(dataInicioApadrinhamento, "dd/MM/yyyy", new Date())
                    )
                  );
                }),
              informacaoComplementar: Yup.string().nullable(),
            })
          )
          .required("Por favor, adicione e informe o apadrinhamento")
          .min(1, "Por favor, adicione e informe o apadrinhamento"),
        otherwise: Yup.array().of(
          Yup.object().shape({
            tipoPessoaProgApadrinha: Yup.object().nullable(),
            nomePessoaApadrinhamento: Yup.string().nullable(),
            dataInicioApadrinhamento: Yup.string().nullable(),
            dataFimApadrinhamento: Yup.string().nullable(),
            informacaoComplementar: Yup.string().nullable(),
          })
        ),
      }
    ),

    incluidoProgApadrinh: Yup.string().required("Este campo é obrigatório "),

    sendoApadrinhado: Yup.string().when("incluidoProgApadrinh", {
      is: "S",
      then: Yup.string().required("Este campo é obrigatório!"),
      otherwise: Yup.string().nullable(),
    }),
  });

  useEffect(() => {
    if (url.includes("visualizar")) {
      setIsTrueVisualizar(true);
      setRadioClick("");
    }
  }, [setRadioClick, url]);

  useEffect(() => {
    if (url.includes("editar")) {
      setRadioClick("Editar");
    }
  }, [url, setRadioClick]);

  useEffect(() => {
    setEditarCriancaCr(false);
    setAnexarCrianca(false);
  }, [setEditarCriancaCr, setAnexarCrianca]);

  const [initialValues, setInitialValues] = useState({
    pessoasProgramaApadrinhamento: [
      {
        tipoPessoaProgApadrinha: "",
        nomePessoaApadrinhamento: "",
        id: 0,
        dataInicioApadrinhamento: "",
        dataFimApadrinhamento: "",
        informacaoComplementar: "",
      },
    ],

    incluidoProgApadrinh: "",
    sendoApadrinhado: "",
  });

  useEffect(() => {
    if (atualizarApadrinhamento) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setAtualizarApadrinhamento(false);
        setEditarApadrinhamentoCrianca(false);
      });
    } else if (cadastrarApadrinhamento) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro cadastrado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setCadastrarApadrinhamento(false);
        setCadastrarApadrinhamentoCrianca(false);
      });
    }
  }, [
    setEditarApadrinhamentoCrianca,
    atualizarApadrinhamento,
    setAtualizarApadrinhamento,
    cadastrarApadrinhamento,
    setCadastrarApadrinhamento,
    setCadastrarApadrinhamentoCrianca,
  ]);

  const onKeyDown = (keyEvent) => {
    if (keyEvent.code === "Enter" || keyEvent.code === "NumpadEnter") {
      keyEvent.preventDefault();
    }
  };

  function parseDateString(data) {
    if (!data) return null;

    const dataOcorrenciaObj = parse(data, "dd/MM/yyyy", new Date());

    const horaAtual = new Date();

    const diferencaFusoHorario = dataOcorrenciaObj.getTimezoneOffset() / 60;

    dataOcorrenciaObj.setHours(
      horaAtual.getHours() - diferencaFusoHorario,
      horaAtual.getMinutes(),
      horaAtual.getSeconds()
    );

    return dataOcorrenciaObj?.toISOString();
  }

  const handleSubmit = (values, actions) => {
    setTimeout(async () => {
      const {
        incluidoProgApadrinh,
        sendoApadrinhado,
        pessoasProgramaApadrinhamento,
      } = values;

      const valuesToSend = {
        pessoasProgramaApadrinhamento:
          sendoApadrinhado === "S" && incluidoProgApadrinh === "S"
            ? pessoasProgramaApadrinhamento.map((pessoa) => ({
                id: pessoa?.id ? pessoa?.id : 0,
                informacaoComplementar: pessoa?.informacaoComplementar
                  ? pessoa?.informacaoComplementar
                  : "",
                nomePessoaApadrinhamento: pessoa?.nomePessoaApadrinhamento
                  ? pessoa?.nomePessoaApadrinhamento
                  : "",
                tipoPessoaProgApadrinha:
                  pessoa.tipoPessoaProgApadrinha?.idTipo === 1
                    ? "P"
                    : pessoa.tipoPessoaProgApadrinha?.idTipo === 2
                    ? "M"
                    : null,
                dataInicioApadrinhamento: pessoa.dataInicioApadrinhamento
                  ? parseDateString(pessoa.dataInicioApadrinhamento)
                  : "",

                dataFimApadrinhamento: pessoa.dataFimApadrinhamento
                  ? parseDateString(pessoa.dataFimApadrinhamento)
                  : "",
              }))
            : [],

        incluidoProgApadrinh: incluidoProgApadrinh,
        sendoApadrinhado: incluidoProgApadrinh === "S" ? sendoApadrinhado : "N",
      };

      if (isTrueVisualizar) {
        setRadioClick("Editar");
        setIsTrueVisualizar(!isTrueVisualizar);
        history.push(`/crianca/editar-apadrinhamento/${id}`);
      } else {
        if (radioClick === "Editar") {
          CriancaService.putCriancaApadrinhamento(values?.id, id, valuesToSend)
            .then((res) => {
              history.push(`/crianca/visualizar-apadrinhamento/${id}`);
              setIsTrueVisualizar(true);
              setRadioClick("");
              setEditarApadrinhamentoCrianca(false);
              setCadastrarApadrinhamentoCrianca(false);

              setAtualizarApadrinhamento(true);
            })
            .catch((error) => {
              console.log(error?.response?.data);
              Swal.fire({
                title: "Atenção!",
                text: error?.response?.data?.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
        } else {
          CriancaService.postCriancaApadrinhamento(id, valuesToSend)
            .then((res) => {
              history.push(`/crianca/visualizar-apadrinhamento/${id}`);
              setIsTrueVisualizar(true);
              setRadioClick("");
              setCadastrarApadrinhamentoCrianca(false);
              setEditarApadrinhamentoCrianca(false);

              setCadastrarApadrinhamento(true);
            })
            .catch((error) => {
              console.log(error.response.data);
              Swal.fire({
                title: "Atenção!",
                text: error.response.data.message
                  ? error.response.data.message
                  : "",
                icon: "error",
                confirmButtonText: "Fechar",
                confirmButtonColor: "#169499",
              });
            });
        }
      }

      actions.setSubmitting(false);
    });
  };

  return roleKeycloack &&
    (roleKeycloack?.includes(criancaFunc.apadrinhamentoVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    <>
      <Flex flex={1} flexDir="column" alignItems="center" overflow="auto">
        <Flex flexDir="column" w="100%">
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize
          >
            {(props) => (
              <Form onKeyDown={onKeyDown}>
                {setEditarApadrinhamentoCrianca(
                  hasFormChanged(initialValues, props.values)
                )}

                <FocusError />
                {isTrueVisualizar ? (
                  <VisualizarPageApadrinhamento
                    id={id}
                    setIsTrueVisualizar={setIsTrueVisualizar}
                    setRadioClick={setRadioClick}
                    setInitialValues={setInitialValues}
                    url={url}
                  />
                ) : roleKeycloack &&
                  (roleKeycloack?.includes(
                    criancaFunc.apadrinhamentoCadastrar
                  ) ||
                    ((roleKeycloack?.includes(
                      criancaFunc.visualizarTudoAcolhimento
                    ) ||
                      roleKeycloack?.includes(
                        criancaFunc.visualizarTudoTutelar
                      )) &&
                      user?.orgaoExterno?.includes(idPJ))) ? (
                  <ApadrinhamentoCadastrar
                    initialValues={initialValues}
                    valuesProps={props.values}
                  />
                ) : (
                  <Box mt={4}>
                    <SemRegistros buttonVisible={true} half />
                  </Box>
                )}
                <Flex justifyContent="flex-end">
                  <Flex justifyContent="flex-end" gap={4}>
                    <Button
                      mt="30px"
                      px="45px"
                      h="42px"
                      color="#FFF"
                      backgroundColor="#169499"
                      fontWeight={700}
                      fontSize="15px"
                      lineHeight="21.6px"
                      _hover={{ bg: "#169499" }}
                      isLoading={props.isSubmitting}
                      onClick={() => onOpen()}
                    >
                      {"Histórico"}
                    </Button>

                    <Permission
                      roleKeycloack={roleKeycloack}
                      func={criancaFunc.apadrinhamentoEditar}
                      user={user}
                      id={idPJ}
                      visualizar={true}
                    >
                      
                      <Button
                        type={isTrueVisualizar ? "button": "submit"}
                        translate="no"
                        mt="30px"
                        px="45px"
                        h="42px"
                        color="#FFF"
                        backgroundColor="#169499"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight="21.6px"
                        onClick={()=>{
                          isTrueVisualizar && history.push( history.push(`/crianca/editar-apadrinhamento/${id}`));
                        }}
                        _hover={{ bg: "#169499" }}
                        isLoading={props.isSubmitting}
                      >
                        {isTrueVisualizar ? "Editar" : "Salvar"}
                      </Button>
                    </Permission>
                  </Flex>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
        <HistoricoApadrinhamento
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          idCrianca={id}
          atualizarApadrinhamento={atualizarApadrinhamento}
          cadastrarApadrinhamento={cadastrarApadrinhamento}
        />
      </Flex>
    </>
  ) : (
    <Box mt={2}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
